// extracted by mini-css-extract-plugin
module.exports = {"info":"Filters_info__27k47","group":"Filters_group__2zDfn","checkbox":"Filters_checkbox__1m2a8","btns":"Filters_btns__uJbO4","button":"Filters_button__bAMPN"};